<template>
  <div class="chat-good" style="width:200px;">
    <img style="width:200px;height:200px;" :src="good.picture" />
    <div class="p-10 bg-white">
      <div class="mb-5 fs-14 clamp">{{good.title}}</div>
      <div class="color-primary fs-14">￥{{good.price}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      good: {
        id: '',
        picture: '',
        title: '',
        price: ''
      }
    }
  },
  created () {
    if (this.data) {
      this.good.id = this.data.id
      this.good.picture = this.data.picture
      this.good.title = this.data.title
      this.good.price = this.data.price
    }
  }
}
</script>

<style lang="scss" scoped>

</style>